import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';

import { FlowNodeTypes } from '../../powerFlowShared/components/types';
import { getRequestID } from '../../shared/util/request';
import { emailFlowActions } from '../actions/emailFlowActions';
import { addFlow, getFlow, updateFlow } from '../api/emailFlow';

const {
  emailFlowGet,
  emailFlowGetSucceeded,
  emailFlowGetFailed,
  emailFlowAdd,
  emailFlowAddSucceeded,
  emailFlowAddFailed,
  emailFlowEdit,
  emailFlowEditSucceeded,
  emailFlowEditFailed,
  emailFlowAddNode,
  emailFlowBuildInit,
} = emailFlowActions;

function* buildInit() {
  const initNodeId = getRequestID();
  const initOptions = {
    id: initNodeId,
    nodeType: FlowNodeTypes.INIT,
    pageX: 1800,
    pageY: 700,
    isAction: false,
    text: 'Incoming Email',
  };
  const emptyActionShown = {
    parentId: initNodeId,
    pageX: 2070,
    pageY: 800,
  };

  yield put(emailFlowAddNode({ node: initOptions }));
  yield put(emailFlowAddNode({ node: emptyActionShown }));
}

// Saga
export const emailFlow = [
  takeLatest(
    emailFlowGet.toString(),
    sagaApiGenWithPromise(getFlow, emailFlowGetSucceeded, emailFlowGetFailed),
  ),
  takeEvery(
    emailFlowAdd.toString(),
    sagaApiGenWithPromise(addFlow, emailFlowAddSucceeded, emailFlowAddFailed),
  ),
  takeEvery(
    emailFlowEdit.toString(),
    sagaApiGenWithPromise(
      updateFlow,
      emailFlowEditSucceeded,
      emailFlowEditFailed,
    ),
  ),

  takeLatest(emailFlowBuildInit.toString(), buildInit),
];
